import styled from 'styled-components';

export const MfaPanelRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
`;

export const MfaPanelContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const MfaPanelBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const ResendLink = styled.a`
  font-size: 14px;
  color: ${({ $cooling }) => ($cooling ? '#cbcacc' : '#0600b4')};
  text-decoration: underline;
  cursor: ${({ $cooling }) => ($cooling ? 'default' : 'pointer')};
  background: none;
  border: none;
  padding: 0;
`;

export const CooldownTimer = styled.span`
  font-size: 14px;
  color: #a30283;
  margin-left: 4px;
`;

export const DigitBoxContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
`;

export const DigitBox = styled.input`
  width: 48px;
  height: 48px;
  border: 1px solid ${({ error }) => (error ? '#c00' : 'var(--prs-c-gray-600, #69686f)')};
  border-radius: 3px;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  padding: 4px;
  background: white;
  color: #0e0d16;

  &:focus {
    outline: 2px solid #0600b4;
    outline-offset: 1px;
  }
`;

export const RememberDeviceLabel = styled.label`
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const LockoutTimerText = styled.p`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: #a30283;
  margin: 16px 0;
`;

export const LockoutBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;
